import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium tracking-wide transition-colors",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[var(--color-foreground)] text-[var(--color-card)]",
        secondary:
          "border-transparent bg-[var(--color-border)]/70 text-[var(--color-foreground)]",
        outline: "border-[var(--color-border)] text-[var(--color-muted)]",
        success:
          "border-transparent bg-[var(--color-ok)]/15 text-[var(--color-ok)]",
        destructive:
          "border-transparent bg-[var(--color-destructive)]/15 text-[var(--color-destructive)]",
        primary:
          "border-transparent bg-[var(--color-primary)]/15 text-[var(--color-primary)]",
      },
    },
    defaultVariants: {
      variant: "secondary",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}
